import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import useApp from '@/pages/App.context';
import styles from '@/pages/Auth/Auth.module.scss';

const ForgotPasswordResult = () => {
  const { t } = useTranslation(['auth']);
  const { setAppTitle } = useApp();

  useEffect(() => {
    setAppTitle(t('auth:forgotten.resultTitle'));
  }, [setAppTitle, t]);

  return (
    <>
      <h2 className={styles.heading}>{t('auth:forgotten.resultTitle')}</h2>
      <div className={styles.text}>{t('auth:forgotten.resultDesc')}</div>
    </>
  );
};

export default ForgotPasswordResult;
